import { render, staticRenderFns } from "./Change.vue?vue&type=template&id=330bfd1c&scoped=true&"
import script from "./Change.vue?vue&type=script&lang=ts&"
export * from "./Change.vue?vue&type=script&lang=ts&"
import style0 from "./Change.vue?vue&type=style&index=0&id=330bfd1c&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330bfd1c",
  null
  
)

export default component.exports